module.exports = __webpack_public_path__ + "static/media/ship-placeholder.52fb07ad.png";